import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  OnDestroy,
  OnInit,
  NgZone,
  ChangeDetectorRef,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import * as moment from 'moment-timezone';
import {
  Observable,
  interval,
  startWith,
  map,
  takeWhile,
  of,
  Subscription,
} from 'rxjs';
import { LoadingSpinnerDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/loading-spinner-dialog/loading-spinner-dialog.component';
import { LodgeComplaintDiaogComponent } from 'src/app/common/modules/dialog-pop-ups/components/lodge-complaint-diaog/lodge-complaint-diaog.component';
import { PollResultDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/poll-result-dialog/poll-result-dialog.component';
import { PreApproveDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/pre-approve-dialog/pre-approve-dialog.component';
import { PreApprovedVisitorDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/pre-approved-visitor-dialog/pre-approved-visitor-dialog.component';
import { PreapprovedSelectionDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/preapproved-selection-dialog/preapproved-selection-dialog.component';
import { RapidScheduleVisitorComponent } from 'src/app/common/modules/dialog-pop-ups/components/rapid-schedule-visitor/rapid-schedule-visitor.component';
import { SnoozeIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/snooze-incident-dialog/snooze-incident-dialog.component';
import { UserEventDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/user-event-dialog/user-event-dialog.component';
import { UserPollsDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/user-polls-dialog/user-polls-dialog.component';
import { UserPreapprovedDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/user-preapproved-dialog/user-preapproved-dialog.component';
import { UserSelfAttendnaceDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/user-self-attendnace-dialog/user-self-attendnace-dialog.component';
import { VerifyIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/verify-incident-dialog/verify-incident-dialog.component';
import { VisitorDetailsDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/visitor-details-dialog/visitor-details-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { environment } from 'src/app/environments/environments';
import { IIncidents } from 'src/app/models/incident';
import {
  INoticeBoardPosts,
  PostStatus,
  ReportStatus,
} from 'src/app/models/notice-board';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { IUserEvents } from 'src/app/models/user-events';
import { IUserPolls } from 'src/app/models/user-polls';
import { Visitor } from 'src/app/models/visitor';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { getSelectedDateVisitorTableData } from 'src/app/utils/table-utils';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDashboardComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Output() onAcceptOrRejectPost = new EventEmitter<any>();
  @Output() postFlaggedpostAction = new EventEmitter<any>();
  @Output() onScheduleVisitor = new EventEmitter<any>();
  @Output() onLodgeUserComplaint = new EventEmitter<any>();
  @Output() onSendBulkInvitation = new EventEmitter<any>();
  @Output() onCreateUserPost = new EventEmitter<any>();
  @Output() onRefreshUserPost = new EventEmitter<any>();
  @Output() onPostUserComment = new EventEmitter<any>();
  @Output() onSaveUserReportPost = new EventEmitter<any>();
  @Output() onPostUserLike = new EventEmitter<any>();
  @Output() onPreApproveVisitor = new EventEmitter<any>();
  @Output() onCreateUserPoll = new EventEmitter<any>();
  @Output() onSubmitPollResponse = new EventEmitter<any>();
  @Output() onRemovePreApprovedVisitor = new EventEmitter<any>();
  @Output() OnVisitorCheckout = new EventEmitter<any>();
  @Output() onInitIncidentManualEvent = new EventEmitter<any>();
  @Output() onInitAddGateEntry = new EventEmitter<any>();
  @Output() onCreateSecurityCallback = new EventEmitter<any>();
  @Output() onShareUserPoll = new EventEmitter<any>();
  @Output() clickedScanQR = new EventEmitter<any>();
  @Output() updateVisitorDetails = new EventEmitter<any>();
  @Output() onVerifyUserIncident = new EventEmitter<any>();
  @Output() clickedAdvancedSOS = new EventEmitter<any>();
  @Output() closeNoticeBoard = new EventEmitter<any>();
  @Output() markAsArrivedVisitor = new EventEmitter<any>();
  @Output() clusterPreApprovedVisitor = new EventEmitter<any>();
  @Output() onSnoozeIncidentDetails = new EventEmitter<any>();
  @Output() clusteredApprovedVisitorArrived = new EventEmitter<any>();
  @Output() onLogUserAttendance = new EventEmitter<any>();
  @Output() isPreverifiedFlow = new EventEmitter<any>();
  @Output() isAumyeCommunityFlow = new EventEmitter<any>();

  @Input() set showNoticeBoard(val: boolean) {
    if (val) this.noticeBoard();
  }

  @Input() set dashboardData(val: IDashboardState) {
    if (val) this.setDashboardData(val);
  }
  @Input() set screenSize(val: ScreenType) {
    this.screenInfo = val;
  }

  @Input() set clickedDashboadGoStepOne(val: boolean) {
    if (val && this.stepper) {
      this.stepper.selectedIndex = 0;
    }
  }

  @ViewChild('LodgeComplainDialog', { static: true })
  lodgeComplainDialog: TemplateRef<any>;
  @ViewChild('SendBulkInvitesDialog', { static: true })
  sendBulkInvitesDialog: TemplateRef<any>;
  @ViewChild('CreatePollDialog', { static: true })
  createPollDialog: TemplateRef<any>;
  @ViewChild('PreApproveDialog', { static: true })
  preApproveDialog: TemplateRef<any>;
  @ViewChild('NoticeBoardDialog', { static: true })
  noticeBoardDialog: TemplateRef<any>;
  @ViewChild('PostCommentDialog', { static: true })
  postCommentDialog: TemplateRef<any>;
  @ViewChild('RapidVisitorScheduleDialog', { static: true })
  rapidVisitorScheduleDialog: TemplateRef<any>;
  @ViewChild('SecurityCallBackDialog', { static: true })
  securityCallBackDialog: TemplateRef<any>;
  @ViewChild('SecuritySOSDialog', { static: true })
  securitySOSDialog: TemplateRef<any>;
  @ViewChild('SecurityEventDialog', { static: true })
  securityEventDialog: TemplateRef<any>;
  @ViewChild('ClusteringVisitorDialog', { static: true })
  clusteringVisitorDialog: TemplateRef<any>;

  @ViewChild('UserPollDialog', { static: true })
  userPollDialog: TemplateRef<any>;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('SubmitAttendanceDialog', { static: true })
  submitAttendanceDialog: TemplateRef<any>;
  @ViewChild('ErrorAttendanceDialog', { static: true })
  errorAttendanceDialog: TemplateRef<any>;

  userId: string = null;
  fullName: string = null;
  orgId: string = null;
  isShowCreatePollSection: boolean = false;
  isShowNoticeBoardSection: boolean = false;
  isShowPendingApprovalSection: boolean = false;
  isShowCreateManulEvent: boolean = false;
  isShowAddGateEntry: boolean = false;
  isShowBulkInviteSection: boolean = false;
  isPreVerifiedVisitorSection: boolean = false;
  screenInfo: ScreenType;
  orgData: IDashboardState;
  showPreviewSection: boolean = true;
  panelOpenState = false;
  preApprovedVisitor: Visitor[] = [];
  pendingApproval: number = 0;
  isLoaded = false;
  role: string = null;
  pollData: IUserPolls;
  selectedPost: INoticeBoardPosts;
  selectedPostIndex: number | null = null;
  visitorDetails: Visitor;
  expectedVisitors: Visitor[] = [];
  myExpectedVisitors: Visitor[] = [];
  securityCallbackIncidents: IIncidents[] = [];
  criticalIncidents: IIncidents[] = [];
  incidentDetails: IIncidents;
  isShowVisitorTimline = false;
  isShowVisitorDetail = false;
  isShowIncidentDetail = false;
  isShowIncidentTimline = false;
  recentIncidents: IIncidents[] = [];
  recentRequests: ComplaintsTickets[] = [];
  clusteredPreApproved: Visitor[] = [];
  isKiosk: boolean = false;
  selectedOption: 'all' | 'my' = 'all';
  printerAllowed = environment.printerAllowed;
  encryptedData = localStorage.getItem('UserDetails');
  decryptedUserData: any;
  userImage =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAMFBMVEXk5ueutLepr7Ln6erg4uPJzc/T1ti7wMO2u77DyMqzuLvq7O3P0tTW2dvc3+DZ3N7ueM45AAAC2UlEQVR4nO2a2ZLjIAxFAYHZvPz/3za2O8v0JCA5kl3dxXly5eXeCAmDZKU6nU6n0+l0Op1O5/cCAErZglofzle3UwxJryTvFnWuB4DJa2P0DWNSnM+zAHnUD/G7Cb/kc/Tz9EJ+t3DKQkB8Lb8xiDsAFSr62jhhB2BTRX51EEUdgK3Lb4kg6qDx/6VjAL6tXxyMUg7A1fLvyYHQngQLTr/szUIGAlJfqBhhxAagIKCvAC+vtUQIBkIAtOE3kNEZsBkQKEVKALQO3AZIKbiGwHIbQG2CTwbYX8w0fa253wgzbQVKEvDqA6kIN5gNIN9DT8y8BiJVXy8XGzATrwFiFa51+McMXL4Elyfh1WVIOw1s8OorS96K/9rL6PLXMfVAorkPJApoBvivqLQ1MBP/oRR9MdsQuBcA4mp+D4DI3WwihEDkdorPAv4j8U67P/ONVJcGvRdYqRZJ9hgHEiV4A9OjkGsRbVTblJu+dKuy4UBcvxRjtVUr3ywup7P38uGUoQHM74Lgzprd5OVFJpgoVv6vLMzu35FNGE+eGq1TqzH6kFIKPg7XDM4y3Mhnz8zK/7XLMLq44cZhmfdfTxDPah5jKKu+ck+B9TlFNynRYKzDSheek+9nIWiT4mBlIlGCPnj9ZmD3bMLo4Gb2kthHpS3xhwk/sFoA5RLxXmLKvsQ1SAVbG1VWPISFIwpF/oj6bsEzWHg1pyZYiJ/lQl6oa/+fAz1+kAr52OL/sJCOBgHm5gEQybFjEgw86nrLBDqZ3herOPDkRKh+pnDAAXV8wKyvqQMMfn2aA9b1fzhA5wFQWhF48N9WkLuiWAfY/YA0pCWBamAfaIyjQTWQ0Y2YA2B6B5k8nCHRDgB5REqi3T6gT6eINNdANADtUpQsgR3fCIDcHnCjPkiQ2gQf1NfgwJSeTPVscmA+SSbVVgD/tdYHVJOAMJQ4TG2ma78bD6LwjtU7nU6n8/v5AuY6HZyRatEhAAAAAElFTkSuQmCC';

  loggedIsUsernameProfile = localStorage.getItem('ProfilePic')
    ? localStorage.getItem('ProfilePic')
    : this.userImage;
  constructor(
    private dialog: MatDialog,
    private actions$: Actions,
    private router: Router,
    private zone: NgZone,
    private cdRef: ChangeDetectorRef,
    private encryptionService: EncryptionService
  ) {
    this.actions$
      .pipe(ofType(fromDashboardActions.DashboardActionTypes.INIT_DASHBOARD))
      .subscribe(() => {
        this.stepper.selectedIndex = 0;
        this.closeSection();
      });
    this.decryptedUserData = this.encryptionService.decrypt(this.encryptedData);
    this.role = this.decryptedUserData.Role?.toLowerCase();
    this.orgId = this.decryptedUserData.OrganizationID?.toLowerCase();
    this.userId = this.decryptedUserData.UserID?.toLowerCase();
    this.fullName =
      this.decryptedUserData.FirstName + ' ' + this.decryptedUserData.LastName;
  }
  ngOnInit(): void {
    this.subscriptions = [];
    this.isKiosk = this.role === 'kiosk';
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.cdRef.detectChanges(); // Manually trigger change detection
    }, 1000);
  }

  scrollToPost(index: number) {
    this.noticeBoard();
    setTimeout(() => {
      this.selectedPostIndex = index;
      const postCardElements = document.querySelectorAll(
        '.posts-card-container'
      );
      if (index >= 0 && index < postCardElements.length) {
        const targetElement = postCardElements[index];
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
      setTimeout(() => {
        this.selectedPostIndex = null;
      }, 1000);
    }, 1000);
  }
  isAllowedAttendance = false;
  setDashboardData(val: IDashboardState) {
    if (
      !val.flows.isIncidentManualEvent &&
      !val.flows.isVisitorGateEntry &&
      !val.flows.isPreverifiedFlow &&
      !val.flows.isAumyeCommunityFlow
    ) {
      this.closeSection();
    }
    this.orgData = val;
    this.isLoaded = true;
    if (!this.isKiosk) {
      if (this.orgData.orgUserList.length > 0) {
        this.isAllowedAttendance =
          this.orgData.orgUserList.find(
            (x) => x.userId.toLowerCase() == this.userId.toLowerCase()
          ).isSelfAttendance == 'true';
      }

      this.preApprovedVisitor = val.visitorDetails.visitorList.filter(
        (item) =>
          item.isPreApproved === 'true' &&
          new Date().getDate() ==
            new Date(item.visitDateTime + 'Z').getDate() &&
          (this.userId === item.hostUserId || this.role == 'admin')
      );
      this.pendingApproval = val.visitorDetails.visitorList.filter(
        (x) =>
          x.isGateEntry == '1' &&
          x.securityStatus == 0 &&
          x.isPreApproved != 'true'
      ).length;
      this.getExpectedVisitors(this.selectedOption);
      this.getSecurityCallbackIncidents();
      this.getCriticalIncidents();
    }
  }
  preVerifiedVisitor() {
    this.isPreverifiedFlow.emit();
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 7;
      this.isPreVerifiedVisitorSection = true;
    } else {
      this.showPreviewSection = false;
      this.isPreVerifiedVisitorSection = true;
      this.isShowPendingApprovalSection = false;
      this.isShowBulkInviteSection = false;
      this.isShowCreatePollSection = false;
      this.isShowNoticeBoardSection = false;
      this.isShowCreateManulEvent = false;
      this.isShowAddGateEntry = false;
    }
  }
  scheduleVisitor() {
    this.showPreviewSection = false;
    this.isShowPendingApprovalSection = false;
    this.isShowBulkInviteSection = false;
    this.isShowCreatePollSection = false;
    this.isShowNoticeBoardSection = false;
    const dialogRef = this.dialog.open(RapidScheduleVisitorComponent, {
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        console.log(result);
        this.dialog.open(this.rapidVisitorScheduleDialog, {
          disableClose: false,
        });

        result.visitDateTime = new Date(result.visitDateTime).toISOString();
        let matchedUser = this.orgData.orgUserList.find(
          (x) => x.userId == this.userId
        );
        result = {
          ...result,
          hostUserId: this.userId,
          hostName: this.fullName,
          visitorCategory: 'Rapid Visitor',
          selectedHosts: [
            {
              HostName: this.fullName,
              HostUserId: matchedUser.userId,
              HostEmail: matchedUser.email,
              HostPhone: matchedUser.phoneNumber,
            },
          ],
        };
        this.onScheduleVisitor.emit(result);
        this.cdRef.detectChanges();
      } else {
        this.showPreviewSection = true;
        this.cdRef.detectChanges();
      }
    });
  }
  lodgeComplaint() {
    this.showPreviewSection = false;
    this.isShowPendingApprovalSection = false;
    this.isShowBulkInviteSection = false;
    this.isShowCreatePollSection = false;
    this.isShowNoticeBoardSection = false;
    const dialogRef = this.dialog.open(LodgeComplaintDiaogComponent, {
      disableClose: true,
      data: this.orgData.orgUserList,
      width: '420px',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.dialog.open(this.lodgeComplainDialog, {
          disableClose: false,
        });
        this.onLodgeUserComplaint.emit(result);
        this.showPreviewSection = true;
        this.cdRef.detectChanges();
      } else {
        this.showPreviewSection = true;
        this.cdRef.detectChanges();
      }
    });
  }
  onClickScanQr() {
    this.clickedScanQR.emit();
  }
  pendingapprovals(step: MatStepper) {
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 1;
      this.isShowPendingApprovalSection = true;
    } else {
      this.showPreviewSection = false;
      this.isShowPendingApprovalSection = true;
      this.isShowBulkInviteSection = false;
      this.isShowCreatePollSection = false;
      this.isShowNoticeBoardSection = false;
      this.isShowAddGateEntry = false;
      this.isShowCreateManulEvent = false;
      this.isPreVerifiedVisitorSection = false;
    }
  }
  createEvent(step: MatStepper) {
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 4;
      this.isShowBulkInviteSection = true;
    } else {
      this.showPreviewSection = false;
      this.isShowPendingApprovalSection = false;
      this.isShowBulkInviteSection = true;
      this.isShowCreatePollSection = false;
      this.isShowNoticeBoardSection = false;
      this.isShowAddGateEntry = false;
    }
  }
  createPoll(step: MatStepper) {
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 2;
      this.isShowCreatePollSection = true;
    } else {
      this.showPreviewSection = false;
      this.isShowCreatePollSection = true;
      this.isShowPendingApprovalSection = false;
      this.isShowBulkInviteSection = false;
      this.isShowNoticeBoardSection = false;
      this.isShowAddGateEntry = false;
    }
  }
  noticeBoard(step?: MatStepper) {
    this.isAumyeCommunityFlow.emit();
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 3;
      this.isShowNoticeBoardSection = true;
    } else {
      this.showPreviewSection = false;
      this.isShowNoticeBoardSection = true;
      this.isShowCreatePollSection = false;
      this.isShowPendingApprovalSection = false;
      this.isShowBulkInviteSection = false;
      this.isShowAddGateEntry = false;
    }
    setTimeout(() => {
      const targetElement = document.querySelector(
        '.user-dashboard-close-button'
      );
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 500);
  }
  preApprove() {
    this.showPreviewSection = false;
    this.isShowNoticeBoardSection = false;
    this.isShowCreatePollSection = false;
    this.isShowPendingApprovalSection = false;
    this.isShowBulkInviteSection = false;
    this.isShowAddGateEntry = false;
    const dialogRef = this.dialog.open(PreApproveDialogComponent, {
      disableClose: true,
      data: this.orgData.orgUserList,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.dialog.open(this.preApproveDialog, {
          disableClose: false,
        });
        if (
          result.instructionControl === 'Leave with Neighbour' ||
          result.instructionControl === 'Meet with Neighbour'
        ) {
          let hostName;
          this.orgData.orgUserList.forEach((item) => {
            if (item.userId === result.userControl) {
              hostName = item.firstname + ' ' + item.lastname;
            }
          });
          const visitorPreApproved = {
            firstName: result.selectControl,
            lastName: 'Preapproved',
            hostUserId: result.userControl,
            hostName: hostName,
            visitorCategory: `${result.selectControl}`,
            purpose: 'Delivery',
            visitDateTime:
              result.chooseDate == null
                ? new Date().toISOString()
                : new Date(result.chooseDate).toISOString(),
          };
          this.onPreApproveVisitor.emit(visitorPreApproved);
        } else {
          const visitorPreApproved = {
            firstName: result.selectControl,
            lastName: 'Preapproved',
            hostUserId: this.userId,
            hostName: this.fullName,
            visitorCategory: `${result.selectControl}`,
            purpose: 'Delivery',
            visitDateTime:
              result.chooseDate == null
                ? new Date().toISOString()
                : new Date(result.chooseDate).toISOString(),
          };
          this.onPreApproveVisitor.emit(visitorPreApproved);
        }
        this.showPreviewSection = true;
        this.cdRef.detectChanges();
      } else {
        this.showPreviewSection = true;
        this.cdRef.detectChanges();
      }
    });
  }

  closeSection() {
    if (this.isShowNoticeBoardSection) {
      this.closeNoticeBoard.emit();
    }
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 0;
    }
    this.showPreviewSection = true;
    this.isShowPendingApprovalSection = false;
    this.isShowBulkInviteSection = false;
    this.isShowCreatePollSection = false;
    this.isShowNoticeBoardSection = false;
    this.isShowCreateManulEvent = false;
    this.isShowAddGateEntry = false;
    this.isPreVerifiedVisitorSection = false;
    this.pollData = null;
  }
  sendBulkInvitation(val: any) {
    const bulkInviteData = {
      eventTitle: val.eventTitle,
      inviteReason: val.inviteReason,
      linkEvent: val.linkEvent,
      guestList: val.uploadFileGuestList,
      eventDate: val.eventDate,
      eventAttachment: val.eventAttachment,
      eventHost: this.fullName,
      eventHostId: this.userId,
    };
    this.dialog.open(this.sendBulkInvitesDialog, { disableClose: false });
    this.onSendBulkInvitation.emit(bulkInviteData);
    this.closeSection();
  }
  createUserPoll(val: any) {
    this.dialog.open(this.createPollDialog, { disableClose: false });
    this.onCreateUserPoll.emit(val);
  }
  createUserPost(val: any) {
    this.dialog.open(this.noticeBoardDialog, { disableClose: false });
    this.onCreateUserPost.emit(val);
  }
  refreshUserPost() {
    this.onRefreshUserPost.emit();
  }
  postUserComment(val: any) {
    this.dialog.open(this.postCommentDialog, { disableClose: false });
    this.onPostUserComment.emit(val);
  }
  postUserLike(val: any) {
    this.onPostUserLike.emit(val);
  }
  saveUserReportPost(val: any) {
    this.onSaveUserReportPost.emit(val);
  }
  openEventDialog(event: IUserEvents): void {
    this.dialog.open(UserEventDialogComponent, {
      width: '400px',
      data: event,
    });
  }
  openPreApprovedVisitorDialog(vis: Visitor): void {
    const dialogRef = this.dialog.open(UserPreapprovedDialogComponent, {
      width: '400px',
      data: vis,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (vis.checkIn == null) {
          const visitorDetail = {
            visitorID: vis.visitorID,
            firstName: vis.firstName,
            lastName: vis.lastName,
            isActive: '0',
          };
          this.onRemovePreApprovedVisitor.emit(visitorDetail);
        } else {
          let matchedUser = this.orgData.orgUserList.find(
            (x) => x.userId == vis.hostUserId
          );
          const visitorDetail = {
            visitorID: vis.visitorID,
            visitorTimline: vis.visitorTimline,
            visitorCommentsTimeline: vis.visitorCommentsTimeline,
            hostUserId: vis.hostUserId,
            hostName: vis.firstName,
            firstName: vis.firstName,
            lastName: vis.lastName,
            hostsDetails: [
              {
                HostName: matchedUser.firstname + ' ' + matchedUser.lastname,
                HostUserId: vis.hostUserId,
                HostPhoneNumber: matchedUser.phoneNumber,
                HostEmail: matchedUser.email,
              },
            ],
          };
          this.OnVisitorCheckout.emit(visitorDetail);
        }
      }
    });
  }
  openUserPollDialog(val: IUserPolls): void {
    const dialogRef = this.dialog.open(UserPollsDialogComponent, {
      data: val,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.dialog.open(this.userPollDialog, {
          disableClose: false,
        });
        this.onSubmitPollResponse.emit(result);
      } else {
        if (!this.isShowNoticeBoardSection) this.showPreviewSection = true;
      }
    });
  }
  checkIsCheckedIn(vis: Visitor) {
    return vis.checkIn != null && vis.checkOut == null;
  }
  checkIsCheckedOOut(vis: Visitor) {
    return vis.checkOut != null;
  }

  createIncident() {
    this.onInitIncidentManualEvent.emit();
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 5;
      this.isShowCreateManulEvent = true;
    } else {
      this.isShowCreateManulEvent = true;
      this.showPreviewSection = false;
    }
  }
  AddGateEntry() {
    this.onInitAddGateEntry.emit();
    this.cdRef.detectChanges();
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 6;
      setTimeout(() => {
        const targetElement = document.querySelector(
          '.user-dashboard-close-button'
        );
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 500);
    } else {
      setTimeout(() => {
        const targetElement = document.querySelector(
          '.user-dashboard-gate-entry-close-button'
        );
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 500);
    }
    this.isShowAddGateEntry = true;
    this.showPreviewSection = false;
    this.isPreVerifiedVisitorSection = false;
    this.isShowPendingApprovalSection = false;
    this.isShowBulkInviteSection = false;
    this.isShowCreatePollSection = false;
    this.isShowNoticeBoardSection = false;
    this.isShowCreateManulEvent = false;
    this.cdRef.detectChanges();
  }
  onOpenCommunityDashboard() {}
  securityCallback() {
    const callbackUser = this.orgData.OrganizationSettings.securityDefault;
    const randomSecurity = this.orgData.orgUserList.find(
      (x) => x.userRole == 'security'
    );
    const _dialogRef = this.dialog.open(this.securitySOSDialog, {
      disableClose: true,
    });

    _dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        const loggedUser = this.userId;
        const userWithAddress = this.orgData.orgUserList.find(
          (user) => user.userId === loggedUser
        );
        const matchedUser = this.orgData.orgUserList.find(
          (user) =>
            user.userId.toLowerCase() === callbackUser.userId.toLowerCase()
        );
        const item = [
          {
            HostName:
              matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
            HostUserId: matchedUser.userId,
            HostEmail: matchedUser.email,
            HostPhone: matchedUser.phoneNumber,
          },
        ];
        const IncidentManual = {
          IncidentType: 'Automatic',
          IncidentName: 'Security Callback',
          IncidentLocation: userWithAddress.userAddress,
          IncidentStatus: 0,
          IncidentCriticality: 'L',
          AssignedTo: callbackUser
            ? callbackUser.fullName
            : randomSecurity.firstname + ' ' + randomSecurity.lastname,
          AssignedToUserId: callbackUser
            ? callbackUser.userId
            : randomSecurity.userId,
          EventCreatedBy:
            userWithAddress.firstname + ' ' + userWithAddress.lastname,
          EventCreatedByUserID: loggedUser,
          SelectedUsers: item,
        };
        this.onCreateSecurityCallback.emit(IncidentManual);
        this.dialog.open(this.securityEventDialog, { disableClose: true });
      }
    });
  }
  step1Data: any = {};
  shareUserPoll(val: IUserPolls) {
    if (this.screenInfo === ScreenType.Mobile) {
      this.stepper.selectedIndex = 3;
      this.pollData = val;
      this.isShowNoticeBoardSection = true;
      setTimeout(() => {
        const targetElement = document.querySelector(
          '.user-dashboard-close-button'
        );
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 250);
    } else {
      this.pollData = val;
      this.showPreviewSection = false;
      this.isShowNoticeBoardSection = true;
      this.isShowCreatePollSection = false;
      this.isShowPendingApprovalSection = false;
      this.isShowBulkInviteSection = false;
    }
  }
  getFormatedDateTime(val: any) {
    const inputTimezone = 'UTC';
    // const date = moment(val, moment.ISO_8601);
    const date = moment.tz(val, moment.ISO_8601, inputTimezone);
    const currentTimezone = moment.tz.guess();
    date.tz(currentTimezone);
    const timeDifference = date.fromNow();
    return timeDifference;
  }
  getLiveAndPendingUserPolls() {
    let polls: IUserPolls[] = this.orgData.userPolls;
    if (polls.length == 0) {
      return []; // or handle this case accordingly
    }
    return polls.filter((poll) => {
      if (poll.pollResponse === null && poll.pollStatus === true) {
        return true;
      }
      return (
        poll.pollStatus === true && !poll.pollResponse.includes(this.userId)
      );
    });
  }
  isShowClusterButton = false;
  temp: Visitor[] = [];
  getExpectedVisitors(val: 'all' | 'my') {
    if (this.orgData.visitorDetails.visitorList.length > 0) {
      this.temp = getSelectedDateVisitorTableData(
        new Date(),
        this.orgData.visitorDetails.visitorList
      ).map((visitor) => ({
        ...visitor,
        timerValue: '', // Initialize timerValue for each visitor
      }));

      if (val == 'my') {
        this.myExpectedVisitors = this.expectedVisitors.filter(
          (vis) => vis.hostUserId === this.userId
        );
      } else {
        this.expectedVisitors = this.temp;
      }

      this.isShowClusterButton =
        this.expectedVisitors.filter((x) => x.isPreApproved === 'true').length >
        1;
      this.clearTimerSubscriptions();
      this.initializeTimers();
    }
  }

  onClickedAdvancedSos() {
    this.clickedAdvancedSOS.emit();
  }
  getSecurityCallbackIncidents() {
    let allIncidents = [
      ...this.orgData.incidentDetails.recentActivityIncidentList,
      ...this.orgData.incidentDetails.noIncidentList,
      ...this.orgData.incidentDetails.lowIncidentList,
      ...this.orgData.incidentDetails.mediumIncidentList,
      ...this.orgData.incidentDetails.criticalIncidentList,
    ];
    this.securityCallbackIncidents =
      this.orgData.incidentDetails.incidentList.filter(
        (incident) => incident.incidentName === 'Security Callback'
      );
    const sortedByDateIncidents = allIncidents.sort(
      (a, b) =>
        new Date(b.eventCreateDate).getTime() -
        new Date(a.eventCreateDate).getTime()
    );
    const recentDate = new Date(
      sortedByDateIncidents[0]?.eventCreateDate + 'Z'
    ).toDateString();
    this.recentIncidents = sortedByDateIncidents.filter((incident) => {
      return (
        new Date(incident.eventCreateDate + 'Z').toDateString() === recentDate
      );
    });
    // let recentComplaints = this.orgData.complaintsTickets.filter((x) => {
    //   const date1 = new Date(x.complainAddDate);
    //   const date2 = new Date();
    //   const sameDate =
    //     date1.getFullYear() === date2.getFullYear() &&
    //     date1.getMonth() === date2.getMonth() &&
    //     date1.getDate() === date2.getDate();
    //   return sameDate;
    // });
    // let recentClaim = this.orgData.claimTickets.filter((x) => {
    //   const date1 = new Date(x.complainAddDate);
    //   const date2 = new Date();
    //   const sameDate =
    //     date1.getFullYear() === date2.getFullYear() &&
    //     date1.getMonth() === date2.getMonth() &&
    //     date1.getDate() === date2.getDate();
    //   return sameDate;
    // });
    // let recentRequest = this.orgData.requestsTickets.filter((x) => {
    //   const date1 = new Date(x.complainAddDate);
    //   const date2 = new Date();
    //   const sameDate =
    //     date1.getFullYear() === date2.getFullYear() &&
    //     date1.getMonth() === date2.getMonth() &&
    //     date1.getDate() === date2.getDate();
    //   return sameDate;
    // });
    this.recentRequests = [
      ...this.orgData.claimTickets,
      ...this.orgData.requestsTickets,
      ...this.orgData.complaintsTickets,
    ];
    const sortedByDateRecentRequests = this.recentRequests.sort(
      (a, b) =>
        new Date(b.complainAddDate).getTime() -
        new Date(a.complainAddDate).getTime()
    );
    const recentRequestsRecentDate = new Date(
      sortedByDateRecentRequests[0]?.complainAddDate + 'Z'
    ).toDateString();
    this.recentRequests = sortedByDateRecentRequests.filter((incident) => {
      return (
        new Date(incident.complainAddDate + 'Z').toDateString() ===
        recentRequestsRecentDate
      );
    });
    // Filter incidents with incidentStatus = 0
    const incidentsWithStatus0 = this.securityCallbackIncidents.filter(
      (incident) => incident.incidentStatus === 0
    );

    // Filter incidents with other incidentStatus
    const incidentsWithOtherStatus = this.securityCallbackIncidents.filter(
      (incident) => incident.incidentStatus !== 0
    );

    // Sort the incidents, with status 0 first
    const sortedIncidents = incidentsWithStatus0.concat(
      incidentsWithOtherStatus
    );

    const incidentsWithStatus = this.recentIncidents.filter(
      (incident) => incident.incidentStatus === 0
    );
    // Filter incidents with other incidentStatus
    const incidentsWithOtherStatus0 = this.recentIncidents.filter(
      (incident) => incident.incidentStatus !== 0
    );
    // Sort the incidents, with status 0 first
    const sortedIncidents0 = incidentsWithStatus.concat(
      incidentsWithOtherStatus0
    );

    // Assign the sorted array back to the property
    this.securityCallbackIncidents = sortedIncidents;
    this.recentIncidents = sortedIncidents0;
  }
  getCriticalIncidents() {
    this.criticalIncidents = this.orgData.incidentDetails.incidentList.filter(
      (incident) =>
        incident.incidentName === 'Intrusion' ||
        incident.incidentName === 'Fire Verified' ||
        incident.incidentName === 'Fire Unverified'
    );
    // Filter incidents with incidentStatus = 0
    const incidentsWithStatus0 = this.criticalIncidents.filter(
      (incident) => incident.incidentStatus === 0
    );

    // Filter incidents with other incidentStatus
    const incidentsWithOtherStatus = this.criticalIncidents.filter(
      (incident) => incident.incidentStatus !== 0
    );

    // Sort the incidents, with status 0 first
    const sortedIncidents = incidentsWithStatus0.concat(
      incidentsWithOtherStatus
    );

    // Assign the sorted array back to the property
    this.criticalIncidents = sortedIncidents;
  }
  getExpiredUserPolls() {
    return this.orgData.userPolls.filter((poll) => {
      return (
        poll.pollStatus === false || poll?.pollResponse?.includes(this.userId)
      );
    });
  }
  checkIsPollLiveAndResponded(poll: IUserPolls): boolean {
    if (poll.pollStatus === true) {
      return true;
    }
    return false;
  }
  calculateEngagement(poll: IUserPolls) {
    let options: string[] = JSON.parse(poll.pollOptions);
    let pollResponse: any[] = JSON.parse(poll.pollResponse);
    let totalCount = 0;
    for (const option of options) {
      const matchingResponses = pollResponse?.filter(
        (response) => response.Response === option
      );
      const count = matchingResponses ? matchingResponses.length : 0;
      totalCount += count;
    }
    let result = ((totalCount * 100) / 14).toFixed(2);
    return result + '%';
  }
  onInitVisitorGateEntry() {}
  onShowVisitorDetail(val: any) {
    this.visitorDetails = val;
    // this.isShowVisitorDetail = true;
    // this.isShowVisitorTimline = false;
    this.dialog.open(VisitorDetailsDialogComponent, {
      data: val,
    });
  }
  onShowIncidentDetail(val: any) {
    this.incidentDetails = val;
    this.isShowIncidentDetail = true;
    this.isShowIncidentTimline = false;
  }
  isShowUrgentIncidents = false;
  isShowCriticalIncidents = false;
  onShowUrgentIncidentDetail(val: any) {
    this.incidentDetails = val;
    this.isShowUrgentIncidents = true;
    this.isShowCriticalIncidents = false;
    this.isShowIncidentTimline = false;
  }
  onShowCriticalIncidentDetail(val: any) {
    this.incidentDetails = val;
    this.isShowCriticalIncidents = true;
    this.isShowIncidentTimline = false;
    this.isShowUrgentIncidents = false;
  }
  displayedColumns = ['visname', 'hostname', 'time', 'security', 'Details'];
  getExpectedCheckoutTimeNumber(row: any): Observable<number> {
    // Assuming row.checkIn is a valid Date object
    const expectedCheckoutTime = new Date(row.checkIn + 'Z');
    expectedCheckoutTime.setMinutes(expectedCheckoutTime.getMinutes() + 30);

    return interval(1000) // Emit a value every second
      .pipe(
        startWith(0), // Emit the initial value immediately
        map(() => {
          const currentTime = new Date();
          const timeDifferenceInMilliseconds =
            expectedCheckoutTime.getTime() - currentTime.getTime();
          const timeDifferenceInSeconds = Math.max(
            Math.floor(timeDifferenceInMilliseconds / 1000),
            0
          );

          const minutes = Math.floor(timeDifferenceInSeconds / 60);
          const seconds = timeDifferenceInSeconds % 60;
          return minutes + seconds / 100; // Display seconds as a decimal part of the minute
        }),
        takeWhile((time) => time > 0, true) // Stop emitting when time is less than 0
      );
  }
  onPostActionTaken(val: { post: INoticeBoardPosts; action: PostStatus }) {
    const data = {
      postId: val.post.postId,
      reviewNotes: null as string | null, // or just null if your type allows
      action: val.action,
    };
    this.onAcceptOrRejectPost.emit(data);
  }
  goToPost(postId: string): void {
    this.router.navigate(['/dashboard/community', postId]);
  }
  onPostFlaggedpostAction(val: {
    post: INoticeBoardPosts;
    action: ReportStatus;
  }) {
    const data = {
      postId: val.post.postId,
      reviewNotes: null as string | null, // or just null if your type allows
      action: val.action,
    };
    this.postFlaggedpostAction.emit(data);
  }
  getExpectedCheckoutTime(row: any): Observable<string> {
    // Assuming row.checkIn is a valid Date object
    const expectedCheckoutTime = new Date(row.checkIn + 'Z');
    expectedCheckoutTime.setMinutes(expectedCheckoutTime.getMinutes() + 30);

    const currentTime = new Date();
    const timeDifferenceInMilliseconds =
      expectedCheckoutTime.getTime() - currentTime.getTime();
    const timeDifferenceInSeconds = Math.max(
      Math.floor(timeDifferenceInMilliseconds / 1000),
      0
    );

    const minutes = Math.floor(timeDifferenceInSeconds / 60);
    const seconds = timeDifferenceInSeconds % 60;

    // Format minutes and seconds with leading zeros
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    // Display seconds as a decimal part of the minute
    const formattedTime = `${formattedMinutes}:${formattedSeconds}`;

    // Return "minute" or "minutes" based on the value of minutes
    const minuteLabel = minutes === 1 ? 'minute' : 'minutes';
    return of(`${formattedTime} ${minuteLabel}`);
  }
  onShowVisitorDetailDialog(val: any) {
    // http://localhost:4200/dashboard/view?linkType=visitor&id=24d03cf7-ee14-4d50-8d72-2b94375141f7
    this.router.navigateByUrl(
      `/dashboard/view?linkType=visitor&id=${val.visitorID}`
    );
  }
  onShowIncidentDetailDialog(val: any) {
    // http://localhost:4200/dashboard/view?linkType=incident&id=24d03cf7-ee14-4d50-8d72-2b94375141f7
    this.router.navigateByUrl(
      `/dashboard/view?linkType=incident&id=${val.incidentId}`
    );
    // const data = {
    //   incident: val,
    //   users: this.orgData.orgUserList,
    // };
    // const dialogRef = this.dialog.open(IncidentDetailsDialogComponent, {
    //   disableClose: true,
    //   data: data,
    // });
    // dialogRef.componentInstance.snoozeIncident.subscribe((data) => {
    //   if (data) {
    //     let previousDetails = this.orgData.incidentDetails.incidentList.find(
    //       (x) => x.incidentId == data.incidentId
    //     );
    //     if (!previousDetails) {
    //       previousDetails = this.orgData.complaintsTickets.find(
    //         (x) => x.complainId == data.incidentId.toLowerCase()
    //       ).complainIncidentDetails;
    //     }
    //     data['previousStatus'] = previousDetails.incidentStatus;
    //     data['previousAssigned'] = previousDetails.assignedTo;
    //     this.onSnoozeIncidentDetails.emit(data);
    //   }
    // });
  }
  openPreApprovedCluster() {
    const data = this.getOnlyPreApprovedPendingVisitors(this.expectedVisitors);
    const dialogRef = this.dialog.open(PreapprovedSelectionDialogComponent, {
      data: data,
    });
    dialogRef.componentInstance.onClusterPreApproved.subscribe((res) => {
      this.clusteredPreApproved = res;
      // this.clusterPreApprovedVisitor.emit(res);
    });
    dialogRef.afterClosed().subscribe(() => {
      const clusteredVisitors: Visitor[] = this.clusteredPreApproved.slice(1);
      let clusteredPreApprovedTemp: any = { ...this.clusteredPreApproved[0] };
      clusteredPreApprovedTemp['isCluster'] = true;
      clusteredPreApprovedTemp['clusterIds'] = clusteredVisitors;
      this.onActionPreApproved(clusteredPreApprovedTemp);
      // this.dialog.open(this.clusteringVisitorDialog, {
      //   disableClose: true,
      // });
    });
  }
  onActionPreApproved(val: any) {
    if (val.isPreApproved == 'true') {
      const dialogRef = this.dialog.open(PreApprovedVisitorDialogComponent, {
        disableClose: true,
        width: '1080px',
        data: val,
      });
      // dialogRef.afterClosed().subscribe((result: any) => {
      //   if (result) {
      //     this.orgData.orgUserList.forEach((item) => {
      //       if (item.userId === val.hostUserId) {
      //         result['hostEmail'] = item.email;
      //         result['hostUserId'] = item.userId;
      //       }
      //     });
      //     const clusteredVisitors: Visitor[] =
      //       this.clusteredPreApproved.slice(1);
      //     result['isCluster'] = true;
      //     result['clusterIds'] = clusteredVisitors.map((x: any) => x.visitorID);
      //     this.clusteredApprovedVisitorArrived.emit(result);
      //   }
      // });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          const matchedUser = this.orgData.orgUserList.find(
            (user) => user.userId.toLowerCase() === val.hostUserId.toLowerCase()
          );
          const filteredVisitors: Visitor[] =
            this.orgData.visitorDetails.visitorList.filter(
              (x) => x.visitorID == result.visitorId
            );
          result['hostEmail'] = matchedUser.email;
          result['hostUserId'] = matchedUser.userId;
          result['visitorDetails'] = filteredVisitors;

          const item = {
            HostName:
              matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
            HostUserId: matchedUser.userId,
            HostEmail: matchedUser.email,
            HostPhone: matchedUser.phoneNumber,
          };
          result.selectedHosts = [item];
          // this.store.dispatch(
          //   new fromDashboardActions.VisitorNotifyHost(result)
          // );
          console.log(result, 'Check mmmmm');
          // this.markAsArrived(val);
        }
      });
    }
  }
  getOnlyPreApprovedPendingVisitors(val: Visitor[]) {
    return val.filter((index) => index.isPreApproved == 'true');
  }
  onCloseVisitorDetail() {
    this.isShowVisitorDetail = false;
  }
  onVerifyIncident(val: any) {
    let previousStatus = this.orgData.incidentDetails.incidentList.find(
      (x) => x.incidentId == val.incidentId
    );
    if (!previousStatus) {
      previousStatus = this.orgData.complaintsTickets.find(
        (x) => x.complainId == val.incidentId.toLowerCase()
      )?.complainIncidentDetails;
      if (!previousStatus) {
        previousStatus = this.orgData.requestsTickets.find(
          (x) => x.complainId == val.incidentId.toLowerCase()
        )?.complainIncidentDetails;
        if (!previousStatus) {
          previousStatus = this.orgData.claimTickets.find(
            (x) => x.complainId == val.incidentId.toLowerCase()
          ).complainIncidentDetails;
        }
      }
    }
    val['incidentStatusTimeline'] = previousStatus.incidentStatusTimeline;
    val['previousStatus'] = previousStatus.incidentStatus;
    this.onVerifyUserIncident.emit(val);
  }
  onShowVisitorTimeline(val: any) {
    this.isShowVisitorTimline = val;
  }
  onUpdateVisitorDetails(val: Visitor) {
    this.dialog.open(LoadingSpinnerDialogComponent, {
      disableClose: true,
    });
    this.updateVisitorDetails.emit(val);
    this.isShowVisitorDetail = false;
  }
  onCloseIncidentDetail() {
    this.isShowIncidentDetail = false;
    this.isShowIncidentTimline = false;
    this.isShowUrgentIncidents = false;
    this.isShowCriticalIncidents = false;
  }
  // onSnoozeIncident(val: any) {
  //   this.onSnoozeIncidentDetails.emit(val);
  //   this.onCloseIncidentDetail();
  // }
  onSnoozeIncident(val: IIncidents) {
    const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      let previousDetails = this.orgData.incidentDetails.incidentList.find(
        (x) => x.incidentId == val.incidentId
      );
      if (!previousDetails) {
        previousDetails = this.orgData.complaintsTickets.find(
          (x) => x.complainId == val.incidentId.toLowerCase()
        ).complainIncidentDetails;
      }
      let data = {
        isSnooze: true,
        incidentStatusTimeline: val.incidentStatusTimeline,
        durationType: result.durationType,
        durationSize: result.durationSize,
        incidentId: val.incidentId,
        orgId: val.orgId,
        incidenType: val.incidentType,
        incidentName: val.incidentName,
        assignedBy: this.fullName,
        assignedById: this.userId,
        createBy: val.eventCreatedBy,
        createById: val.eventCreatedByUserID,
        assignedTo: val.assignedTo,
        assignedToUserId: val.assignedToUserId,
        evidence: val.eventEvidence,
        previousStatus: previousDetails.incidentStatus,
        previousAssigned: previousDetails.assignedTo,
      };
      if (result) {
        this.onSnoozeIncidentDetails.emit(data);
        this.onCloseIncidentDetail();
      }
    });
  }
  onShowTimeline(val: any) {
    this.isShowIncidentTimline = val;
  }
  onViewPollResult(poll: IUserPolls) {
    this.dialog.open(PollResultDialogComponent, {
      disableClose: false,
      data: poll,
    });
  }
  onClickStatus(val: any) {
    const dialogRef = this.dialog.open(VerifyIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    dialogRef.afterClosed().subscribe((result: string) => {
      let data = {
        status:
          result == 'Open'
            ? '0'
            : result == 'Close'
            ? '1'
            : result == 'Verified'
            ? '2'
            : result == 'Snooze'
            ? '3'
            : result == 'In-Progress'
            ? '4'
            : result == 'On-Hold'
            ? '5'
            : result == 'Approved'
            ? '6'
            : result == 'Rejected'
            ? '7'
            : result == 'Completed'
            ? '8'
            : '',
        incidentId: val.incidentId,
      };
      if (data.status == '3') {
        const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
          disableClose: true,
          data: val,
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          let data = {
            isSnooze: true,
            durationType: result.durationType,
            durationSize: result.durationSize,
            incidentId: val.incidentId,
            status: '3',
          };
          if (result) {
            this.onVerifyIncident(data);
          }
        });
      } else {
        if (result) {
          this.onVerifyIncident(data);
        }
      }
    });
  }
  onMarkAsArrived(val: any) {
    const filteredVisitors: Visitor[] =
      this.orgData.visitorDetails.visitorList.filter(
        (x) => x.visitorID == val.visitorID
      );
    val['visitorDetails'] = filteredVisitors;
    console.log(
      filteredVisitors,
      this.orgData.visitorDetails.visitorList,
      'visitorDetails'
    );
    this.markAsArrivedVisitor.emit(val);
  }
  onClickSelfAttendance() {
    if (this.isAllowedAttendance) {
      const userData = this.orgData.orgUserList.find(
        (x) => x.userId == this.userId
      );
      const dialogRef = this.dialog.open(UserSelfAttendnaceDialogComponent, {
        disableClose: true,
        data: {
          screen: this.screenInfo,
          userData: userData,
        },
      });
      dialogRef.componentInstance.onSubmitAttendance.subscribe((res) => {
        dialogRef.close();
        this.dialog.open(this.submitAttendanceDialog, { disableClose: true });

        const payload = {
          employeeId: userData.userId,
          employeeAttendance: JSON.parse(userData.employeeAttendance),
          shiftType: userData.isNightShift == 'False' ? 'day' : 'night',
          isSelf: true,
        };
        this.onLogUserAttendance.emit(payload);
      });
    } else {
      this.dialog.open(this.errorAttendanceDialog);
    }
  }
  isComplainOrClaim = false;
  getLabel(val: ComplaintsTickets) {
    this.isComplainOrClaim = false;
    if (val.complainSubject == 'Complain' || val.complainSubject == 'Claim') {
      return val.complainSubject;
    }
    return 'Request';
  }
  getFormatedDate(val: any) {
    // let localDate = new Date(val);
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
  subscriptions: Subscription[] = [];
  initializeTimers() {
    this.expectedVisitors.forEach((visitor) => {
      this.startTimer(visitor);
    });
  }
  startTimer(visitor: Visitor) {
    if (visitor.securityStatus === 4 && visitor.inProgressStatusTime) {
      const subscription = interval(1000).subscribe(() => {
        this.updateTimer(visitor);
      });
      this.subscriptions.push(subscription);
    } else if (
      (visitor.securityStatus === 5 || visitor.securityStatus === 1) &&
      visitor.completeStatusTime
    ) {
      const completeStatusTime = new Date(visitor.completeStatusTime);
      const inProgressStatusTime = new Date(visitor.inProgressStatusTime);
      const diff =
        completeStatusTime.getTime() - inProgressStatusTime.getTime();
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      visitor.timerValue = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
        seconds
      )}`;
    }
  }
  updateTimer(visitor: Visitor) {
    const now = new Date();
    const currentTimeUTC = new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    const inProgressTimeUTC = new Date(visitor.inProgressStatusTime).getTime();
    const diff = currentTimeUTC.getTime() - inProgressTimeUTC;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    // Use Angular's change detection
    this.zone.run(() => {
      visitor.timerValue = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
        seconds
      )}`;
    });
  }

  pad(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
  cleanupTimers() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
  private clearTimerSubscriptions() {
    if (this.subscriptions) {
      this.cleanupTimers();
    }
  }
  // applyFilter(event: any) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.expectedVisitors = this.temp.filter((visitor) => {
  //     const firstNameMatch = visitor.firstName
  //       .trim()
  //       .toLowerCase()
  //       .includes(filterValue);
  //     const hostMatch = visitor.hostName.toString().includes(filterValue);
  //     const visitorIdMatch = visitor.visitorID.toString().includes(filterValue); // Assuming visitorId is a number

  //     return firstNameMatch || visitorIdMatch || hostMatch;
  //   });
  // }
  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    this.expectedVisitors = this.temp.filter((visitor) => {
      const firstNameMatch = visitor.firstName
        .trim()
        .toLowerCase()
        .includes(filterValue);

      const lastNameMatch = visitor.lastName
        .trim()
        .toLowerCase()
        .includes(filterValue);

      const fullNameMatch = `${visitor.firstName
        .trim()
        .toLowerCase()} ${visitor.lastName.trim().toLowerCase()}`
        .trim()
        .toLowerCase()
        .includes(filterValue);

      const hostMatch = visitor.hostName
        .toString()
        .toLowerCase()
        .includes(filterValue);

      const phoneNumberMatch = visitor.phoneNumber
        ? visitor.phoneNumber.toString().toLowerCase().includes(filterValue)
        : '';

      const visitorIdMatch = visitor.visitorID.toString().includes(filterValue); // Assuming visitorId is a number

      return (
        firstNameMatch ||
        lastNameMatch ||
        fullNameMatch ||
        visitorIdMatch ||
        hostMatch ||
        phoneNumberMatch
      );
    });
  }
  onSelectionChange(event: any) {
    console.log('Selection changed:', event.value);
    this.selectedOption = event.value;
    if (event.value == 'my') {
      this.getExpectedVisitors(event.value);
    }
    // Handle the selection change logic here
  }
  ngOnDestroy() {
    this.cleanupTimers();
  }
  ScreenType = ScreenType;
}
